/*
 * @Description: 
 * @Author: kai.zhou
 * @Date: 2021-01-27 21:40:56
 * @LastEditors: kai.zhou
 * @LastEditTime: 2021-01-27 21:42:00
 */
/**
 *
 * native结果数据返回格式:
{
    code: 0,
    msg: 'success',
    "requsetCode": 123
    data: {}
}
code: 0成功，1失败
msg: 提示消息
data: 返回数据
requsetCode: 请求码，区分同一方法


 协定协议:jsbridge://carlcare.transsion.com:1234/showToast?params={"message":"hello"};
 1234: 请求码，区分同一方法；
 showToast: Native 方法
 params: 请求参数，json字符串
 */
 var win = window;
 var ua = win.navigator.userAgent;
 var JS_BRIDGE_PROTOCOL_SCHEMA = "jsbridge";
 var JS_BRIDGE_PROTOCOL_HOST = "carlcare.transsion.com";
 var JsBridge = win.JsBridge || (win.JsBridge = {});
 
 var ExposeMethod = {
   callMethod: function (method, requestCode, param, callback, fail) {
     if (typeof callback !== "function") {
       callback = null;
     }
     PrivateMethod.registerCallback(requestCode, callback);
     PrivateMethod.callNativeMethod(method, requestCode, param, fail);
   },
 
   onComplete: function (requestCode, result) {
     PrivateMethod.onNativeComplete(requestCode, result);
   },
 };
 
 var PrivateMethod = {
   callbacks: {},
   registerCallback: function (requestCode, callback) {
     if (callback) {
       PrivateMethod.callbacks[requestCode] = callback;
     }
   },
   getCallback: function (requestCode) {
     var call = {};
     if (PrivateMethod.callbacks[requestCode]) {
       call.callback = PrivateMethod.callbacks[requestCode];
     } else {
       call.callback = null;
     }
     return call;
   },
   unRegisterCallback: function (requestCode) {
     if (PrivateMethod.callbacks[requestCode]) {
       delete PrivateMethod.callbacks[requestCode];
     }
   },
   onNativeComplete: function (requestCode, result) {
     var resultJson = PrivateMethod.str2Json(result);
     var callback = PrivateMethod.getCallback(requestCode).callback;
     PrivateMethod.unRegisterCallback(requestCode);
     if (callback) {
       callback && callback(resultJson);
     }
   },
   str2Json: function (str) {
     if (str && typeof str === "string") {
       try {
         return JSON.parse(str);
       } catch (e) {
         return {
           code: 1,
           msg: "params parse error!",
         };
       }
     } else {
       return str || {};
     }
   },
   json2Str: function (param) {
     if (param && typeof param === "object") {
       return JSON.stringify(param);
     } else {
       return param || "";
     }
   },
   callNativeMethod: function (method, requestCode, param, fail) {
     if (PrivateMethod.isAndroid()) {
       var jsonStr = PrivateMethod.json2Str(param);
       var uri =
         JS_BRIDGE_PROTOCOL_SCHEMA +
         "://" +
         JS_BRIDGE_PROTOCOL_HOST +
         ":" +
         requestCode +
         "/" +
         method +
         "?params=" +
         jsonStr;
       // win.prompt(uri, "");
       //window.location.href = uri;
       if (ua.toLowerCase().indexOf("carlcareapph5") > -1) {
         //CarlCareAppH5
         window.location.href = uri;
       } else {
         if (fail) {
           fail();
         }
       }
     } else {
       if (fail) {
         fail();
       }
     }
   },
   isAndroid: function () {
     var tmp = ua.toLowerCase();
     var android = tmp.indexOf("android") > -1;
     return !!android;
   },
   isIos: function () {
     var tmp = ua.toLowerCase();
     var ios = tmp.indexOf("iphone") > -1;
     return !!ios;
   },
 };
 for (var index in ExposeMethod) {
   if (ExposeMethod.hasOwnProperty(index)) {
     if (!Object.prototype.hasOwnProperty.call(JsBridge, index)) {
       JsBridge[index] = ExposeMethod[index];
     }
   }
 }
 
 class APPJS{
   // 返回promise对象--- 获取carlcare app状态：版本号，当前用户选择国家码，用户手机号以及afid四项数据
   async userinfo(){
     let resData={
       appVersion:'',
       mcc:'',
       afid:'',
       phone:'',
       gaid:'',
       token:"",
     };
    //  resData={
    //     appVersion:'v5.8.2',
    //     mcc:'621',
    //     afid:'17136200922',
    //     phone:'19888131190',//123nha
    //     gaid:'gaid123',
    //     token:"eyJhbGciOiJSUzI1NiJ9.eyJ1c2VyIjoiUlJHY08vcGhJYXJsbWc4dEVJbHp2dFVSRzFVbkFRUXVTWHJNZGFWTGpwS005NHNlUkoyaUhzcUU5WUNIRHVmb0F2eFhYSUlvSzlIS1lQNjVFMjdkM1IvVVo3N2tsNW5Wb1Brc2Z1ZlNPcjdxVmNtY0tVZjdRTEFzT1FuNlB4aTlORUtDbW1tTksvMG1sOE9FU04wMCttM3ROR3NsUEsyeHNOQld5SUZicDF6S1R0WGExYTFyVk1pN1ZoVWxpcUFJRVN3UkFocVI0SEtSTWlUaTVOOVljbU02TFNzUkZ4am4wV2dycGZBTi81Sm90R25HSmtpKzhzRW9DU1dpcU1ZL3I5bmdSM0hSWS81YWgzNGIxUUUzR3RvNU51SkVPbThkOHdQNTVmRXl5cTFWYTlvOGpkOFdrbzVidEhOeEFGNTNJMVNVVzlTaHk1WEpFOWh5NHQyZVc0SHdsSzZBbkR6SnhtaHZGenlOQzRKYlNGNUdhcDJkNnYxaEpQa0dSTU5GIiwiYXBwSWQiOiJjYXJsY2FyZWFwcCIsInNjb3BlIjoiU2NvcGUuQUxMIiwiaXNzIjoieG4iLCJpYXQiOjE3NTU1NzE4MjcsInN1YiI6ImFjY2Vzc1Rva2VuIiwiZXhwIjoxNzU1NzQ0NjI3fQ.NfmbLfjRntdnzW-pctn45Gk1Q2vvefyLrdrCjMdNKiX8d8mIVoSRgjFX3k-QhY3IXwj1MU4gZivNg1SJfD1vnhdFvwyXHIjBVytdQdJvtzGUADtOAr8z9mYziPKNAsiesowWnjg2RjutHnSVk9tU7pAwPt_M2Ncr76KnZfcXCsYmTlFBwR6CxWvGtEfu4sq0x8rsWy0Lmg2asQVv87fC6XRK3ix-JTn0k5CxOc_EDOuAd6o5QHxZW5_NBZHMsZjNB2B3YaJG0wmYzuJyKpKoSZxF5iqyoVqC7dPUOPfNKl8g2_NJDuhQ-7wFgZifpUy2Z9jhhgV3Y_hRo9Jgg8WETw"
    //   };
     let res=await new Promise((resolve)=>{
       // 校验是否在app内部
       JsBridge.callMethod(
         "getAppInfo",
         12345,
         {},
         function (msg) {
           if ((msg.code === "0" || msg.code === 0) && msg.data.appVersion.slice(1) >= "5.7.0.2") {
             resData.appVersion=msg.data.appVersion;
             resData.mcc=msg.data.mcc;
             resData.gaid=msg.data.gaid||'';
             JsBridge.callMethod("getLoginInfo", 123, {}, function (msg1) {
               if (msg1.code === "0" || msg1.code === 0) {
                 if (!!msg1.data.openId) {
                 resData.afid=msg1.data.openId;
                 resData.phone=msg1.data.phone;
                 resData.token=msg1.data.token;
                 }
               }
              //  localStorage.setItem("afid",msg1.data.openId)
               resolve(resData)
             },function(){
               resolve(resData)
             });
           }
         },function(){
           resolve(resData)
         }
       );
     })
     return res
   }
   // 登录功能 ------carlcare弹出登录界面，成功登录后返回用户手机号和Afid 两项数据（promise）
   async userLogin(parm={}){
     let resData={
       afid:'',
       phone:''
     };
     let res=await new Promise((resolve)=>{
       JsBridge.callMethod("login", 123, parm, function (msg) {
         if (+msg.code === 0) {
           if (!!msg.data.openId) {
             resData.afid=msg.data.openId;
             resData.phone=msg.data.phone;
           }
         }
         resolve(resData)
       },function(){
         resolve(resData)
       });
     })
     return res
   }
   //分享功能----text分享的链接或内容
   async share(text,sucFun){
     JsBridge.callMethod("shareCustomH5", 123, {
       "link":encodeURIComponent(text)
     }, function (msg) {
       if (+ msg.code === 0) {
         sucFun();//成功回调
       }
     })
   }
   // 查看定位是否开启
  async hasLocationPermission() {
    /**
     * jsbridge://carlcare.transsion.com:123/hasLocationPermission
     * <p/>
     * response: {"code":0,"data":{"has":true,"permission":"android.permission.ACCESS_FINE_LOCATION"},"requestCode":123}
     */
    let resData=false;
    let res=await new Promise((resolve)=>{
    JsBridge.callMethod("hasLocationPermission", 123, {}, function (msg) {
      if (+msg.code === 0) {
        resData=msg.data
      }
      resolve(resData)
      }, function () {
        resolve(resData)
      })
    })
    return res;
  }
  // 开启定位
  async requestLocationPermission() {
    /**
     * jsbridge://carlcare.transsion.com:123/hasLocationPermission
     * <p/>
     * response: {"code":0,"data":{"has":true,"permission":"android.permission.ACCESS_FINE_LOCATION"},"requestCode":123}
     */
    let resData=false;
    let res=await new Promise((resolve)=>{
      JsBridge.callMethod("requestLocationPermission", 123, {}, function (msg) {
          if (+msg.code === 0) {
            resData=msg.data
          }
          resolve(resData)
        }, function () {
          resolve(resData)
        })
      })
      return res;
    }
    // 新的定位方式
  async requestLocation() {
    /**
     * jsbridge://carlcare.transsion.com:123/hasLocationPermission
     * <p/>
     * response: {"code":0,"data":{"has":true,"permission":"android.permission.ACCESS_FINE_LOCATION"},"requestCode":123}
     */
    let resData=false;
    let res=await new Promise((resolve)=>{
      JsBridge.callMethod("requestLocation", 101, {}, function (msg) {
          if (+msg.code === 0) {
            resData=msg.data
          }
          resolve(resData)
        }, function () {
          resolve(resData)
        })
      })
      return res;
    }
 }
 export default new APPJS();